<template>
  <div 
    class="label-wrapper"
    :class="{
      default: isDefault,
      holiday: isHoliday,
      empty: isEmpty}"
    :style="{ 
      width: width+'px',
      height: height+'px',
      borderRadius: bRadius+'px'}">{{ title }}</div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class Label extends Vue {
  @Prop({ default: 115 }) width;
  @Prop({ default: 18 }) height;
  @Prop({ default: 4 }) bRadius;
  @Prop({ default: 'default' }) type;
  @Prop(String) title;

  get isDefault() {
    return this.type === 'default'
  }

  get isHoliday() {
    return this.type === 'holiday'
  }

  get isEmpty() {
    return this.type === 'empty'
  }

  mounted() {
  }
}
</script>

<style lang="stylus" scoped>
@import '../../../styles/main.core.vars.styl'
.label-wrapper {
  color: #000;
  text-align: center;
  padding-bottom: 2px;
  border-radius: 25px;
  width: max-content;
  padding: 0 10px 2px;
  margin-left: auto;
  margin-right: auto;

  &&.limited {
    font-size: 9px;
  }

  &&.default {
    background: #F2F2F2
  }

  &&.holiday {
    color: #fff;
    background: $red_color
  }
  &&.empty {
    background: linear-gradient(111.94deg,#1befdc,#24ceda);
    color: #fff;
    cursor: pointer;
  }
}</style>